var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Descripción")]),
      _c("div", { staticClass: "values" }, [_vm._v(_vm._s(_vm.dte.tipo_dte))])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Folio")]),
      _c("div", { staticClass: "values" }, [_vm._v(_vm._s(_vm.dte.folio))])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Hora y Fecha")]),
      _c("div", { staticClass: "values" }, [
        _vm._v(_vm._s(_vm.dte.fecha_creacion))
      ])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Estado")]),
      _vm.dte._estado_sii
        ? _c("div", { staticClass: "values" }, [
            _vm._v(_vm._s(_vm.dte._estado_sii) + " "),
            _vm.dte._estado_sii === _vm.siiStates.created
              ? _c("span", [_vm._v("Creado")])
              : _vm.dte._estado_sii === _vm.siiStates.pendingShipping
              ? _c("span", [_vm._v(" Pendiente de envio al sii")])
              : _vm.dte._estado_sii === _vm.siiStates.sent
              ? _c("span", [_vm._v("Enviado al sii")])
              : _vm.dte._estado_sii === _vm.siiStates.sendError
              ? _c("span", [_vm._v("Error al enviar")])
              : _vm.dte._estado_sii === _vm.siiStates.accepted
              ? _c("span", [_vm._v("Aceptado por el sii")])
              : _vm.dte._estado_sii === _vm.siiStates.acceptedWithQualms
              ? _c("span", [_vm._v(" Aceptado con reparos por el sii")])
              : _vm.dte._estado_sii === _vm.siiStates.rejected
              ? _c("span", [_vm._v("Rechazado por el sii")])
              : _vm.dte._estado_sii === _vm.siiStates.pendingConsultation
              ? _c("span", [_vm._v(" Pendiente de consulta en el sii")])
              : _vm.dte._estado_sii === _vm.siiStates.queryError
              ? _c("span", [_vm._v(" Error al consultar en el sii")])
              : _vm.dte._estado_sii === _vm.siiStates.overcast
              ? _c("span", [_vm._v("Ensobrado")])
              : _vm.dte._estado_sii === _vm.siiStates.canceled
              ? _c("span", [_vm._v("Anulado")])
              : _vm.dte._estado_sii === _vm.siiStates.pendingValidation
              ? _c("span", [
                  _vm._v(" Descargado listado, pendiente validacion")
                ])
              : _c("span", [_vm._v("ESTADO DESCONOCIDO")])
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Estado Comercial")]),
      _vm.dte._estado_comercial
        ? _c("div", { staticClass: "values" }, [
            _vm._v("(" + _vm._s(_vm.dte._estado_comercial) + ") "),
            _vm.dte._estado_sii === _vm.commercialStatus.preAccepted
              ? _c("span", [_vm._v("Pre Aceptado")])
              : _vm.dte._estado_sii === _vm.commercialStatus.accepted
              ? _c("span", [_vm._v("Aceptado en el SII")])
              : _vm.dte._estado_sii === _vm.commercialStatus.preRejected
              ? _c("span", [_vm._v("Pre Rechazado")])
              : _vm.dte._estado_sii === _vm.commercialStatus.rejected
              ? _c("span", [_vm._v("Rechazado en el SII")])
              : _vm.dte._estado_sii === _vm.commercialStatus.partialClaim
              ? _c("span", [_vm._v(" Reclamo Parcial en el SII")])
              : _vm.dte._estado_sii === _vm.commercialStatus.totalClaim
              ? _c("span", [_vm._v(" Reclamo Total en el SII")])
              : _vm.dte._estado_sii === _vm.commercialStatus.receiptOfGoods
              ? _c("span", [_vm._v(" Recibo Mercaderias en el SII ")])
              : _vm.dte._estado_sii === _vm.commercialStatus.acceptedByDefault
              ? _c("span", [_vm._v(" Aceptado Por Defecto en el SII ")])
              : _vm.dte._estado_sii === _vm.commercialStatus.noAction
              ? _c("span", [_vm._v("Sin Accion")])
              : _c("span", [_vm._v("Sin Accion")])
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Empresa Emisora")]),
      _c("div", { staticClass: "values" }, [
        _vm._v(
          " " +
            _vm._s(_vm.formatNumber(_vm.dte.rut_emisor.split("-")[0])) +
            " - " +
            _vm._s(_vm.dte.rut_emisor.split("-")[1]) +
            " / " +
            _vm._s(_vm.dte.rzn_soc) +
            " "
        )
      ])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Empresa receptora")]),
      _c("div", { staticClass: "values" }, [
        _vm._v(
          " " +
            _vm._s(_vm.formatNumber(_vm.dte.rut_recep.split("-")[0])) +
            "-" +
            _vm._s(_vm.dte.rut_recep.split("-")[1]) +
            " / " +
            _vm._s(_vm.dte.rzn_soc_recep) +
            " "
        )
      ])
    ]),
    _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Monto")]),
      _c("div", { staticClass: "values" }, [
        _vm._v("$ " + _vm._s(_vm.formatNumber(_vm.dte.mnt_total)))
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex" }, [
      _c("div", { staticClass: "field" }, [_vm._v("Tipo Documento")]),
      _c("div", { staticClass: "values" }, [
        _vm._v("Documento Tributario Electronico")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }